<template>
  <v-container fluid class="ma-0 pa-0">
    <v-row class="ma-0 pa-0">
      <v-col cols="12" md="6">
        <v-card class="elevation-2">
          <v-card-title>
            Top 10 Clienti
            <v-spacer />
            <v-chip small :color="modalita === 'importi' ? 'success' : 'primary'">
              {{ modalita === 'importi' ? 'per Importo' : 'per Ore' }}
            </v-chip>
          </v-card-title>
          <v-card-text style="height: 400px;">
            <doughnut-chart :data="graficoTopClienti" :options="opzioniTorta" :key="keyTop" />
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" md="6">
        <v-card class="elevation-2">
          <v-card-title>
            Distribuzione
            <v-spacer />
            <span class="text-caption text--secondary">
              {{ filtri.anno - 1 }}: stesso periodo dell'anno precedente
            </span>
          </v-card-title>
          <v-card-text>
            <v-simple-table dense>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Cliente</th>
                    <th class="text-right">Ore</th>
                    <th class="text-right">Ore {{ filtri.anno - 1 }}</th>
                    <th class="text-right">Var.</th>
                    <th class="text-right">Importo</th>
                    <th class="text-right">€/h</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(cliente, i) in topClientiTabella" :key="i">
                    <td>{{ cliente.cliente }}</td>
                    <td class="text-right text-no-wrap">{{ cliente.ore.toFixed(0) }} h</td>
                    <td class="text-right text-no-wrap">{{ cliente.orePrec.toFixed(0) }} h</td>
                    <td class="text-right text-no-wrap">
                      <span :class="getVariazioneColor(cliente.varOre)">
                        {{ cliente.varOre === null ? '-' : formattaVariazione(cliente.varOre) }}
                      </span>
                    </td>
                    <td class="text-right text-no-wrap">{{ formattaImporto(cliente.importo) }}</td>
                    <td class="text-right text-no-wrap">
                      <span :class="getTariffaColor(cliente.tariffaMedia)">
                        {{ cliente.tariffaMedia > 0 ? formattaImporto(cliente.tariffaMedia) : '-' }}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row class="ma-0 pa-0 mt-3">
      <v-col cols="12">
        <v-card class="elevation-2">
          <v-card-title>
            Matrice Mensile per Cliente
            <v-spacer />
            <v-chip small :color="modalita === 'importi' ? 'success' : 'primary'" class="mr-2">
              {{ modalita === 'importi' ? 'Importi €' : 'Ore' }}
            </v-chip>
            <v-text-field v-model="ricercaHeatmap" append-icon="search" label="Cerca cliente" single-line hide-details
              dense style="max-width: 300px;" />
          </v-card-title>
          <v-card-text>
            <div class="heatmap-container" style="overflow-x: auto;">
              <table class="heatmap-table">
                <thead>
                  <tr>
                    <th class="text-left sticky-col">Cliente</th>
                    <th v-for="m in 12" :key="m">{{ getNomeMese(m - 1) }}</th>
                    <th class="font-weight-bold">Totale</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="cliente in heatmapFiltrato" :key="cliente.codAnagrafica">
                    <td class="font-weight-bold sticky-col">{{ cliente.cliente }}</td>
                    <td v-for="(val, i) in getDatiHeatmap(cliente)" :key="i"
                      :style="{ backgroundColor: getColoreHeat(val, getMaxHeatmap(cliente)) }" class="text-center">
                      {{ val > 0 ? formattaValore(val) : '-' }}
                    </td>
                    <td class="font-weight-bold text-right">{{ formattaValore(getTotaleHeatmap(cliente)) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row class="ma-0 pa-0 mt-3">
      <v-col cols="12">
        <v-card class="elevation-2">
          <v-card-title>
            Ore totali per tipo
            <v-spacer />
            <span class="text-caption text--secondary">
              Tutte le ore registrate, a prescindere da destinazione e fatturazione (seguono Anno, Cliente e Operatore)
            </span>
          </v-card-title>
          <v-card-text>
            <v-simple-table dense>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Tipo</th>
                    <th class="text-right">Ore</th>
                    <th class="text-right">% sul totale</th>
                    <th class="text-right">Ore {{ filtri.anno - 1 }}</th>
                    <th class="text-right">Var.</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="riga in righeOreTotali" :key="riga.tipo">
                    <td>{{ riga.tipo }}</td>
                    <td class="text-right text-no-wrap">{{ riga.ore.toFixed(0) }} h</td>
                    <td class="text-right text-no-wrap">{{ riga.percentuale.toFixed(0) }}%</td>
                    <td class="text-right text-no-wrap">{{ riga.orePrec.toFixed(0) }} h</td>
                    <td class="text-right text-no-wrap">
                      <span :class="getVariazioneColor(riga.varOre)">
                        {{ riga.varOre === null ? '-' : formattaVariazione(riga.varOre) }}
                      </span>
                    </td>
                  </tr>
                  <tr v-if="oreTotali" class="font-weight-bold">
                    <td>Totale</td>
                    <td class="text-right text-no-wrap">{{ oreTotali.ore.toFixed(0) }} h</td>
                    <td class="text-right text-no-wrap">100%</td>
                    <td class="text-right text-no-wrap">{{ oreTotali.orePrecedente.toFixed(0) }} h</td>
                    <td class="text-right text-no-wrap">
                      <span :class="getVariazioneColor(oreTotali.orePrecedente > 0 ? oreTotali.tendenza : null)">
                        {{ oreTotali.orePrecedente > 0 ? formattaVariazione(oreTotali.tendenza) : '-' }}
                      </span>
                    </td>
                  </tr>
                  <tr v-else>
                    <td colspan="5" class="text-center text--secondary">Nessun dato disponibile</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { get_top_clienti_ore, get_heatmap_clienti_ore, get_ore_totali } from "@/api/api.clienti.js";
import DoughnutChart from "@/components/chart/DoughnutChart.js";
import mixinCharts from "@/components/chart/mixinCharts.js";
import mixinRichieste from "./mixinRichieste.js";

export default {
  name: "TabComposizioneOre",

  components: {
    DoughnutChart
  },

  mixins: [mixinCharts, mixinRichieste],

  props: {
    filtri: { type: Object, default: () => ({}) },
    modalita: { type: String, default: 'importi' },
    aggiornaDati: { type: Number, default: 0 }
  },

  data: () => ({
    graficoTopClienti: {},
    opzioniTorta: {},
    keyTop: 0,

    topClientiTabella: [],
    datiHeatmap: [],
    ricercaHeatmap: '',
    oreTotali: null
  }),

  computed: {
    // Ore totali per tipo (solo i tipi con ore, e sempre "Lavoro")
    righeOreTotali() {
      if (!this.oreTotali) return [];

      return this.oreTotali.perTipo
        .filter(t => t.ore > 0 || t.orePrecedente > 0 || t.tipo === 'Lavoro')
        .map(t => ({
          tipo: t.tipo,
          ore: t.ore,
          orePrec: t.orePrecedente,
          percentuale: this.oreTotali.ore > 0 ? t.ore / this.oreTotali.ore * 100 : 0,
          varOre: t.orePrecedente > 0 ? (t.ore - t.orePrecedente) / t.orePrecedente * 100 : null
        }));
    },

    heatmapFiltrato() {
      if (!this.ricercaHeatmap) return this.datiHeatmap;

      const cerca = this.ricercaHeatmap.toLowerCase();
      return this.datiHeatmap.filter(c =>
        c.cliente.toLowerCase().includes(cerca)
      );
    }
  },

  methods: {
    async caricaDatiTopClienti() {
      const attuale = this.nuovaRichiesta('topClienti');
      // Copio i filtri subito: i dati mostrati corrispondono sempre a quelli presenti quando è partita la richiesta
      const filtri = Object.assign({}, this.filtri, { modalita: this.modalita });
      try {
        let res = await get_top_clienti_ore(filtri);
        if (!attuale()) return;

        if (res && res.data) {
          const labels = res.data.map(c => c.cliente);
          const dati = this.modalita === 'importi'
            ? res.data.map(c => c.importo)
            : res.data.map(c => c.ore);

          this.graficoTopClienti = {
            labels: labels,
            datasets: [{
              data: dati,
              backgroundColor: ['#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', '#9966FF',
                '#FF9F40', '#4BC0C0', '#9966FF', '#C9CBCF', '#FF6384', '#858585']
            }]
          };

          this.topClientiTabella = res.data.map(c => ({
            cliente: c.cliente,
            importo: c.importo,
            ore: c.ore,
            orePrec: c.orePrecedente,
            varOre: c.orePrecedente > 0 ? (c.ore - c.orePrecedente) / c.orePrecedente * 100 : null,
            tariffaMedia: c.ore > 0 ? c.importo / c.ore : 0
          }));

          this.keyTop++;
        }

      } catch (error) {
        console.error("Errore caricamento top clienti:", error);
      }
    },

    async caricaDatiHeatmap() {
      const attuale = this.nuovaRichiesta('heatmap');
      const filtri = Object.assign({}, this.filtri, { modalita: this.modalita });
      try {
        let res = await get_heatmap_clienti_ore(filtri);
        if (!attuale()) return;

        if (res && res.data) {
          this.datiHeatmap = res.data;
        }

      } catch (error) {
        console.error("Errore caricamento heatmap:", error);
      }
    },

    async caricaOreTotali() {
      const attuale = this.nuovaRichiesta('oreTotali');
      const filtri = Object.assign({}, this.filtri);
      try {
        let res = await get_ore_totali(filtri);
        if (!attuale()) return;

        this.oreTotali = res && res.data ? res.data : null;

      } catch (error) {
        console.error("Errore caricamento ore totali:", error);
      }
    },

    getDatiHeatmap(cliente) {
      return this.modalita === 'importi' ? cliente.mesiImporti : cliente.mesiOre;
    },

    getTotaleHeatmap(cliente) {
      const dati = this.getDatiHeatmap(cliente);
      return dati.reduce((a, b) => a + b, 0);
    },

    getMaxHeatmap(cliente) {
      const dati = this.getDatiHeatmap(cliente);
      return Math.max(...dati);
    },

    getNomeMese(indice) {
      const mesi = ['Gen', 'Feb', 'Mar', 'Apr', 'Mag', 'Giu', 'Lug', 'Ago', 'Set', 'Ott', 'Nov', 'Dic'];
      return mesi[indice];
    },

    getColoreHeat(valore, max) {
      if (valore === 0) return '#f5f5f5';
      const intensita = valore / max;

      if (this.modalita === 'importi') {
        // Verde per importi
        const r = Math.floor(76 + (255 - 76) * (1 - intensita));
        const g = Math.floor(175 + (255 - 175) * (1 - intensita));
        const b = Math.floor(80 + (255 - 80) * (1 - intensita));
        return `rgba(${r}, ${g}, ${b}, 0.7)`;
      } else {
        // Blu per ore
        const r = Math.floor(33 + (255 - 33) * (1 - intensita));
        const g = Math.floor(150 + (255 - 150) * (1 - intensita));
        const b = Math.floor(243 + (255 - 243) * (1 - intensita));
        return `rgba(${r}, ${g}, ${b}, 0.7)`;
      }
    },

    formattaImporto(valore) {
      return '€' + this.$functions.numberWithCommas(valore.toFixed(2));
    },

    formattaValore(valore) {
      if (this.modalita === 'importi') {
        return '€' + this.$functions.numberWithCommas(valore.toFixed(0));
      } else {
        return valore.toFixed(0) + 'h';
      }
    },

    getTariffaColor(tariffa) {
      if (tariffa === 0) return '';
      if (tariffa < 30) return 'error--text';
      if (tariffa < 50) return 'warning--text';
      return 'success--text';
    },

    getVariazioneColor(variazione) {
      if (variazione === null || variazione === 0) return '';
      return variazione > 0 ? 'success--text' : 'error--text';
    },

    formattaVariazione(variazione) {
      return (variazione > 0 ? '+' : '') + variazione.toFixed(0) + '%';
    },

    caricaTuttiDati() {
      this.caricaDatiTopClienti();
      this.caricaDatiHeatmap();
      this.caricaOreTotali();
    }
  },

  mounted() {
    this.opzioniTorta = this.getOptionsDoughnutChart();
    this.caricaTuttiDati();
  },

  watch: {
    aggiornaDati() {
      this.opzioniTorta = this.getOptionsDoughnutChart();
      this.caricaTuttiDati();
    },

    modalita() {
      // la classifica dei clienti dipende dalla modalità (ore o importi)
      this.caricaDatiTopClienti();
      this.caricaDatiHeatmap();
    }
  }
}
</script>

<style scoped>
.heatmap-table {
  width: 100%;
  border-collapse: collapse;
}

.heatmap-table th,
.heatmap-table td {
  border: 1px solid #e0e0e0;
  padding: 8px;
  font-size: 0.875rem;
}

.heatmap-table th {
  background-color: #f5f5f5;
  font-weight: 600;
  position: sticky;
  top: 0;
  z-index: 10;
}

.heatmap-table .sticky-col {
  position: sticky;
  left: 0;
  background-color: #fff;
  z-index: 5;
}

.heatmap-table th.sticky-col {
  z-index: 15;
  background-color: #f5f5f5;
}
</style>